import React, { useCallback, useEffect, useState } from "react";
import { getCustomersAPI } from "../../utils/APIs/customerApis";
import Loader from "../../Loader/Loader";
import CustomerTable from "./CustomerTable/CustomerTable";
import "./Customer.css"
import AddCustomerModal from "./AddCustomerModal/AddCustomerModal";
const Customer = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [page, setPage] = useState(() => {
    const savedPage = sessionStorage.getItem("customerPage");
    return savedPage ? Number(savedPage) : 1;
  });
  const [total, setTotal] = useState(0);

  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const stored = sessionStorage.getItem("isSidebarOpen");
    return stored !== null ? JSON.parse(stored) : true;
  });



  useEffect(() => {
    const interval = setInterval(() => {
      const stored = sessionStorage.getItem("isSidebarOpen");
      const parsed = stored !== null ? JSON.parse(stored) : true;

      if (parsed !== isSidebarOpen) {
        setIsSidebarOpen(parsed);
      }
    }, 10);

    return () => clearInterval(interval);
  }, [isSidebarOpen]);

  useEffect(() => {
    sessionStorage.setItem("customerPage", page);
  }, [page]);

  const mapCustomersResponse = (users = []) =>
    users.map((item) => ({
      id: item._id,
      name: item.username || "-",
      email: item.email || "-",
      mobile: item.mobileNumber || "-",
      dob: item.dateOfBirth || "-"
        ? new Date(item.dateOfBirth).toLocaleDateString("en-IN")
        : "-",
      state: item.state || "-",
      city: item.city || "-",
    }));

 const fetchCustomers = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getCustomersAPI(page, 10);
      setCustomers(mapCustomersResponse(res?.data?.data));
      setTotal(res?.data?.meta?.total);
    } catch (err) {
      console.error("Customer fetch failed", err);
    } finally {
      setLoading(false);
    }
  }, [page]);

 useEffect(() => {
  fetchCustomers();
}, [fetchCustomers]);

  const LIMIT = 10;
  const totalPages = Math.ceil(total / LIMIT);

  if (loading) return <Loader />;

  return (
    <div
      className={`content-container ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"
        }`}
      style={{ marginTop: "100px" }}
    >
      <div className="page-inner-wrapper">
        <h2 className="page-title">Customer</h2>

        <div className="add-customer-btn">
          <button
            className="add-booking-btn"
            onClick={() => setIsModalOpen(true)}
          >
            + Add Customer
          </button>

          <AddCustomerModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onSuccess={fetchCustomers}
          />
        </div>

        <CustomerTable data={customers} page={page} limit={LIMIT} />


        {total > LIMIT && (
          <div className="pagination">
            <button
              className="pagination-btn"
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            >
              Prev
            </button>

            <span className="pagination-info">
              Page {page} of {totalPages}
            </span>

            <button
              className="pagination-btn"
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
            >
              Next
            </button>
          </div>
        )}


      </div>
    </div>
  );
};

export default Customer;
